export const getAuthToken = () => {
  const parsedToken = JSON.parse(localStorage.getItem("access_token"));

  return parsedToken;
};

export const convertToTitleCase = (str) => {
  if (!str) return "";
  // Handle non-string values
  const strValue = typeof str === 'string' ? str : (str?.name || str?.toString() || "");
  if (!strValue) return "";
  return strValue.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
    return match.toUpperCase();
  });
};

export const setAuthToken = (token) =>
  localStorage.setItem("adminNewSideCXHSJSJJSJSJSJSJS:token", token);

export const getUserToken = () => {
  return localStorage.getItem("adminNewSideuserJSJSJSJS:user");
};

export const setUserToken = (token) =>
  localStorage.setItem("adminNewSideuserJSJSJSJS:user", JSON.stringify(token));

export const setLocationHistory = (location) =>
  sessionStorage.setItem("user:redirect:location", JSON.stringify(location));

export const getLocationHistory = () => {
  return JSON.parse(sessionStorage.getItem("user:redirect:location"));
};

export const dateFromString = (dateInString, reverse = false) => {
  const parsedDate = new Date(dateInString);
  if (isNaN(parsedDate.getTime())) {
    return ""; // or "Invalid date"
  }
  const dateYear = parsedDate.getFullYear();
  const dateMonth = parsedDate.getMonth() + 1;
  const dateDay = parsedDate.getDate();
  if (reverse) {
    return `${dateYear}-${dateMonth < 10 ? "0" : ""}${dateMonth}-${
      dateDay < 10 ? "0" : ""
    }${dateDay}`;
  }
  return `${dateDay < 10 ? "0" : ""}${dateDay}-${
    dateMonth < 10 ? "0" : ""
  }${dateMonth}-${dateYear}`;
};

/**
 * Check if the current environment is non-production (staging, development, test)
 * @returns {boolean} true if non-prod, false if production
 */
export const isNonProductionEnvironment = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL || "";
  const nodeEnv = process.env.NODE_ENV || "";
  
  // Check if base URL contains staging indicators
  const isStaging = baseUrl.includes("stag") || baseUrl.includes("staging") || baseUrl.includes("test");
  
  // Check if NODE_ENV indicates non-production
  const isNonProd = nodeEnv !== "production";
  
  return isStaging || isNonProd;
};
